import { Injectable } from '@angular/core';
import { AngularFireStorage, AngularFireUploadTask } from '@angular/fire/storage';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  public task:        AngularFireUploadTask;
  public percentage:  Observable<number>;
  public snapshot:    Observable<any>;
  public downloadUrl: string;
  public fileUrl:     string;
  
  constructor(private _fireStorage: AngularFireStorage) { }

  uploadFile: (folder: string, filename: string, file: any) => Promise<string> = (folder, filename, doc) => {
    return new Promise((resolve, reject) => {
      let path        = `${folder}/${filename}`;
      let ref         = this._fireStorage.ref(path);
      let file        = doc;
      this.task       = this._fireStorage.upload(path, file);
      this.percentage = this.task.percentageChanges();
      this.task.snapshotChanges().pipe(finalize(async () => {
        this.fileUrl = await ref.getDownloadURL().toPromise();
        resolve(this.fileUrl);
      })).subscribe(() => { }, err => reject(err));
    });
  }

  deleteFileByUrl: (fileUrl: string) => Promise<string> = (fileUrl) => {
    return new Promise(async (resolve, reject) => {
      let ref = this._fireStorage.storage.refFromURL(fileUrl);
      ref.delete().then(() => resolve()).catch((err) => reject(err));
    });
  }
}
